import { useEffect, useRef } from "react";
import "./Contact.css";

export default function Contact() {
  const sectionRef = useRef(null);

  const ripple = (e) => {
    const btn = e.currentTarget;
    const r = btn.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;

    btn.style.setProperty("--px", `${x}%`);
    btn.style.setProperty("--py", `${y}%`);

    btn.classList.remove("is-rippling");
    // trigger reflow
    // eslint-disable-next-line no-unused-expressions
    btn.offsetWidth;
    btn.classList.add("is-rippling");
  };

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => el.classList.add("is-mounted"));

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    io.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, []);

  return (
    <section id="contact" className="section contactSection" ref={sectionRef}>
      {/* decorative layer */}
      <div className="contact__bg" aria-hidden="true">
        <span className="contact__orb contact__orb--1" />
        <span className="contact__orb contact__orb--2" />
      </div>

      <div className="container">
        <span className="kicker reveal" style={{ "--d": "0ms" }}>
          Contact
        </span>
        <h2 className="h2 reveal" style={{ "--d": "90ms" }}>
          Let’s grow your business
        </h2>
        <p className="p reveal" style={{ "--d": "180ms" }}>
          Send a message. We’ll reply with a simple plan and pricing.
        </p>

        <div className="contact__grid mt24">
          <div className="contact__left card reveal contactCard" style={{ "--d": "270ms" }}>
            <h3 className="contact__title">Contact details</h3>
            <p className="contact__text">📞 WhatsApp: +94 70 513 5373</p>
            <p className="contact__text">✉️ Email: nesflixdigital@gmail.com</p>
            <p className="contact__text">📍 Sri Lanka</p>
            <hr className="hr" />
            <p className="contact__text">Prefer WhatsApp? Click the button and message us.</p>

            <a
  className="btn btn-primary contact__btn"
  href="https://wa.me/94705135373?text=Hi%20NesflixDigital%20-%20I%20need%20marketing%20support."
  target="_blank"
  rel="noreferrer"
  onPointerDown={ripple}
>
  WhatsApp Now
</a>

          </div>

          <form
            className="contact__form card reveal contactCard"
            style={{ "--d": "360ms" }}
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="contact__row">
              <div className="field">
                <label>Name</label>
                <input className="control" placeholder="Your name" />
              </div>
              <div className="field">
                <label>Phone</label>
                <input className="control" placeholder="07X XXX XXXX" />
              </div>
            </div>

            <div className="contact__row">
              <div className="field">
                <label>Email</label>
                <input className="control" placeholder="you@email.com" />
              </div>
              <div className="field">
                <label>Service</label>
                <select className="control">
                  <option>Meta Ads</option>
                  <option>Content & Design</option>
                  <option>SEO / Google Ads</option>
                  <option>Full Package</option>
                </select>
              </div>
            </div>

            <div className="field">
              <label>Message</label>
              <textarea className="control" rows="5" placeholder="Tell us your business and goal..." />
            </div>

            <button
              className="btn btn-primary contact__submit"
              type="submit"
              onPointerDown={ripple}
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
